import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery, Loader, Carousel, SliderCarousel } from '@grandvisionhq/common';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import '@swc/helpers';
import '@grandvisionhq/analytics';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/utils';
import '../../ProductBlock/types.js';
import '@grandvisionhq/frk-routing';
import '../../ProductBlock/utils/get-variant-images.js';
import { ExtendedProductBlock } from '../../ProductBlock/containers/ExtendedProductBlock.js';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/inventory';
import '@grandvisionhq/api-client';

const ProductBanner = ({ products , className , isLoading =true , hasError , 'data-t': dataT , reimbursableLogos , onProductInteraction , onProductImpression , productLocation ,  })=>{
    const isBigScreen = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    const isPhone = MediaQuery.useIsPhone();
    const itemsPerSlide = MediaQuery.useIsDesktop() ? 4 : 3;
    const classNames = classnames('product-banner', className);
    const { getLabel  } = useIntl();
    const [activeIndex, setActiveIndex] = React.useState(0);
    const carouselItems = React.useMemo(()=>{
        if (!isBigScreen || !products) {
            return [];
        }
        const items = [];
        const max = Math.ceil(products.length / itemsPerSlide);
        for(let i = 0; i < max; i++){
            const start = i * itemsPerSlide;
            const end = (i + 1) * itemsPerSlide;
            items.push(/*#__PURE__*/ React.createElement("div", {
                key: `product-banner-slide-${i}`,
                className: "product-banner__carousel-item"
            }, products.slice(start, end).map((product, index)=>{
                const tabIndex = activeIndex !== i ? -1 : undefined;
                return /*#__PURE__*/ React.createElement(ExtendedProductBlock, {
                    onClick: ()=>{
                        return onProductInteraction === null || onProductInteraction === void 0 ? void 0 : onProductInteraction(product, index);
                    },
                    onImpression: ()=>{
                        return onProductImpression === null || onProductImpression === void 0 ? void 0 : onProductImpression(product, index);
                    },
                    key: product.slug,
                    product: product,
                    reimbursableLogos: reimbursableLogos,
                    tabIndex: tabIndex,
                    productLocation: productLocation
                });
            })));
        }
        return items;
    }, [
        isBigScreen,
        products,
        itemsPerSlide,
        onProductInteraction,
        onProductImpression,
        reimbursableLogos,
        activeIndex,
        productLocation, 
    ]);
    if (hasError) {
        return /*#__PURE__*/ React.createElement("div", {
            className: classNames,
            "data-t": dataT || 'product-banner'
        }, /*#__PURE__*/ React.createElement(Alert, {
            variant: "warning",
            className: "alert-m-default"
        }, getLabel('products.banner.errorMessage')));
    }
    if (isLoading) {
        return /*#__PURE__*/ React.createElement("div", {
            className: classNames,
            "data-t": dataT || 'product-banner'
        }, /*#__PURE__*/ React.createElement(Loader, null));
    }
    // Render a regular carousel on large screens and a slider carousel on smaller screens
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames,
        "data-t": dataT || 'product-banner'
    }, isBigScreen ? /*#__PURE__*/ React.createElement(Carousel, {
        shouldLoopNavigationFocus: true,
        onIndexChange: setActiveIndex
    }, carouselItems) : /*#__PURE__*/ React.createElement(SliderCarousel, {
        itemWidth: isPhone ? 186 : 246
    }, products.map((product, index)=>{
         return React.createElement(ExtendedProductBlock, {
            onClick: ()=>{
                return onProductInteraction === null || onProductInteraction === void 0 ? void 0 : onProductInteraction(product, index);
            },
            onImpression: ()=>{
                return onProductImpression === null || onProductImpression === void 0 ? void 0 : onProductImpression(product, index);
            },
            key: product.slug,
            product: product,
            reimbursableLogos: reimbursableLogos,
            productLocation: productLocation
        });
    })));
};

export { ProductBanner };
//# sourceMappingURL=ProductBanner.js.map
